module.exports = __webpack_public_path__ + "img/DE05731.cd13cc5e.png";